/**
 * Build a usable asset URL. Absolute URLs (e.g. S3) are returned unchanged;
 * relative paths are prefixed with the API base URL.
 */
export function resolveApiAssetUrl(
  pathOrUrl: string | undefined | null,
  apiBaseUrl: string | undefined | null
): string {
  if (pathOrUrl == null || pathOrUrl === "") {
    return "";
  }
  const trimmed = pathOrUrl.trim();
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  const base = (apiBaseUrl ?? "").replace(/\/$/, "");
  const path = trimmed.replace(/^\//, "");
  return base ? `${base}/${path}` : `/${path}`;
}
